import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-cash-out.svg";
import * as styles from "./Icon.module.scss";

type CashOutProps = React.SVGProps<SVGSVGElement>;

export const CashOut = ({ className, ...props }: CashOutProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
